export enum PaymentTypesEnum {
    Invoice = 'invoice',
    Coupon = 'coupon'
}